import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-black pt-16 pb-8" data-id="element-3">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-4">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4" data-id="element-5">
          {/* Company Info */}
          <div className="lg:col-span-2" data-id="element-6">
            <div className="flex items-center gap-2 text-xl font-bold text-white mb-4" data-id="element-7">
              <span data-id="element-8">AVL AI LLP</span>
            </div>
            <p className="text-sm text-gray-400 mb-4" data-id="element-9">
              STONEY WORKS 8 STONEY LANE
              <br data-id="element-10" />
              LONDON
              <br data-id="element-11" />
              UNITED KINGDOM SE19 3BD
            </p>
          </div>

          {/* Website Sections */}
          <div data-id="element-12">
            <h3 className="text-sm font-semibold text-white mb-4" data-id="element-13">Website</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-14">
              <li data-id="element-15">
                <a href="#solutions" className="hover:text-white transition-colors" data-id="element-16">
                  Solutions
                </a>
              </li>
              <li data-id="element-17">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-18">
                  About
                </a>
              </li>
              <li data-id="element-19">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-20">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-21">
            <h3 className="text-sm font-semibold text-white mb-4" data-id="element-22">Legal</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-23">
              <li data-id="element-24">
                <a href="#terms" className="hover:text-white transition-colors" data-id="element-25">
                  Terms and Conditions
                </a>
              </li>
              <li data-id="element-26">
                <a href="#privacy" className="hover:text-white transition-colors" data-id="element-27">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/5 pt-8" data-id="element-28">
          <p className="text-xs text-gray-500 text-center" data-id="element-29">
            &copy; {new Date().getFullYear()} AVL AI LLP. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}